// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__LqpW5","label":"Completed_label__2VY7r"};